/** @jsxImportSource @emotion/react */
import type { FC } from 'react';
import cx from 'classnames';
import { connectSearchBox } from 'react-instantsearch-dom';

import querySuggestions from '../../../data/search-query-suggestions';
import styles from '../../../css/pages/search.css';

interface QuerySuggestionsProps {
  refine: (event: string) => void;
}



const QuerySuggestions: FC<QuerySuggestionsProps> = ({ refine }) => (
  <ul className="mt-0 mb-0 p-0 lis-none d-none fxw-nowrap md:d-flex">
   {/* {querySuggestions.map((suggestion:any, index:any) => (
      <li className={cx('fxg-1', index > 0 && 'ml-16')} key={suggestion}>
        <button
          onClick={() => refine(suggestion)}
          css={styles.querySuggestions}
          className="fxw-tags algolia_btn cursor-pointer color-grey-500 bdr-4 d-block w-100p h-100p p-8 fsz-12 app-none bdw-0 bgc-grey-100 hover:bgc-asteroid"
        >
          {suggestion}
        </button>
      </li>
    ))}*/}
    {/* {
      querySuggestions('https://dummyjson.com/carts').then((response: any) => {
        console.log("test purpose", response)
        response['data']['carts'][0]['products'].map((suggestion:any, index:any) => (
          <li className={cx('fxg-1', index > 0 && 'ml-16')} key={index}>
            <button
              onClick={() => refine(suggestion.title)}
              css={styles.querySuggestions}
              className="cursor-pointer color-grey-500 bdr-4 d-block w-100p h-100p p-8 fsz-12 app-none bdw-0 bgc-grey-100 hover:bgc-asteroid"
            >
              {suggestion.title}
            </button>
          </li>
        ));
      })
    } */}
  </ul>
);

/* const QuerySuggestions = querySuggestions('https://dummyjson.com/carts').then((response: any) => {
    console.log("test purpose", response)
    response['data']['carts'][0]['products'].map((suggestion:any, index:any) => (
      <li className={cx('fxg-1', index > 0 && 'ml-16')} key={index}>
        <button
          css={styles.querySuggestions}
          className="cursor-pointer color-grey-500 bdr-4 d-block w-100p h-100p p-8 fsz-12 app-none bdw-0 bgc-grey-100 hover:bgc-asteroid"
        >
          {suggestion.title}
        </button>
      </li>
    ));
}) */
    

export default connectSearchBox(QuerySuggestions);
